import { sinFunction } from "./implementation/MathematicalFunctions.js";

export const MathematicalFunctions = {
    SIN_FUNCTION: sinFunction
};
